import { Component, OnInit } from "@angular/core";
import { AnimationItem } from "lottie-web";
import { AnimationOptions } from "ngx-lottie";
import { NgForm } from "@angular/forms";
import { HttpService } from "../http.service";
import { ValidationService } from "../validation.service";
import { SnackbarService } from "../snackbar.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-request-call-back",
  templateUrl: "./request-call-back.component.html",
  styleUrls: ["./request-call-back.component.scss"],
})
export class RequestCallBackComponent implements OnInit {
  path: string = "assets/get_in_touch.json";
  text: string = "";

  options: AnimationOptions = {
    path: this.path, // Replace with your JSON animation path
  };
  formData = {
    organization_type: "",
    company: "",
    functions: "",
    department: "",
    shipment_volume_per_month: "",
    fleet_size: "",
    service_type: "",
    city: "",
    name: "",
    official_email: "",
    phone_no: "",
    industry:""
  };

  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }
  constructor(
    private http: HttpService,
    private valid: ValidationService,
    private snackbar: SnackbarService,
    private translate: TranslateService
  ) {}

  ngOnInit() {}

  openModal() {
    document.getElementById("modal_for_demo").style.display = "flex";
    document.getElementById("overlay_modal").style.display = "flex";
  }

  closeModal() {
    document.getElementById("modal_for_demo").style.display = "none";
    document.getElementById("overlay_modal").style.display = "none";
  }

  handleChange() {
    if(this.formData.organization_type == 'Shipper') {
      this.formData.fleet_size = ''
      this.formData.service_type = ''
    } else  {
      this.formData.industry = ''
      this.formData.shipment_volume_per_month = ''
    }
    this.formData.functions = ''
    this.formData.department = ''
  }

  requestCallback() {
    const valid = this.validate(this.formData);
    if (valid) {
      if(this.formData.organization_type == 'Shipper') {
        delete this.formData.service_type 
        delete this.formData.fleet_size
      } else if(this.formData.organization_type == 'Carrier'){
        delete this.formData.industry
        delete this.formData.shipment_volume_per_month
        delete this.formData.functions
        delete this.formData.department
      } else if(this.formData.organization_type == '4PL') {
        delete this.formData.industry
        delete this.formData.shipment_volume_per_month
      }
      this.http
        .post("add/instavans/callBack", this.formData)
        .subscribe((data: any) => {
          if (data.statusCode === 200) {
            this.openModal();
            this.snackbar.openSnackBar("Team will contact you, Thank you", "");
            this.formData = {
              organization_type: "",
              company: "",
              functions: "",
              department: "",
              shipment_volume_per_month: "",
              fleet_size: "",
              service_type: "",
              city: "",
              name: "",
              official_email: "",
              phone_no: "",
              industry: ""
            };
    }}, 
    (err: any)=>{
      this.snackbar.openSnackBar(
        this.translate.instant("Something went wrong, please try again!"),
        "",
        "err"
      )})
    }
  }
  validate(data) {
    if (
      !this.valid.isEmpty(this.formData.organization_type) &&
      !this.valid.isEmpty(this.formData.company) &&
      !this.valid.isEmpty(this.formData.phone_no) &&
      !this.valid.isEmpty(this.formData.city) &&
      !this.valid.isEmpty(this.formData.name) &&
      !this.valid.isEmpty(this.formData.official_email)
    ) {
      if( this.formData.organization_type == 'Shipper' &&
      this.valid.isEmpty(this.formData.functions) &&
      this.valid.isEmpty(this.formData.department)
      && this.valid.isEmpty(this.formData.shipment_volume_per_month) 
      && this.valid.isEmpty(this.formData.industry) ) {
        this.snackbar.openSnackBar(
          this.translate.instant("MESSAGE.addSpotDriver.allDetails"),
          "",
          "err"
        );
        return false;
      } else if(this.formData.organization_type == '4PL' 
        &&    this.valid.isEmpty(this.formData.functions) &&
        this.valid.isEmpty(this.formData.department) &&
       this.valid.isEmpty(this.formData.service_type) &&
       this.valid.isEmpty(this.formData.fleet_size)
      ) {
        this.snackbar.openSnackBar(
          this.translate.instant("MESSAGE.addSpotDriver.allDetails"),
          "",
          "err"
        );
        return false;
      } else if(this.formData.organization_type == 'Carrier' && this.valid.isEmpty(this.formData.service_type) &&
      this.valid.isEmpty(this.formData.fleet_size) ) {
        this.snackbar.openSnackBar(
          this.translate.instant("MESSAGE.addSpotDriver.allDetails"),
          "",
          "err"
        );
        return false;
      }
 



      if (!this.valid.isMobile(this.formData.phone_no)) {
        this.snackbar.openSnackBar(
          this.translate.instant("MESSAGE.addSpotDriver.mobile"),
          "",
          "err"
        );
        return false;
      }
      if (!this.valid.isEmail(this.formData.official_email)) {
        this.snackbar.openSnackBar(
          this.translate.instant("Please enter valid email"),
          "",
          "err"
        );
        return false;
      }
} else {
      this.snackbar.openSnackBar(
        this.translate.instant("MESSAGE.addSpotDriver.allDetails"),
        "",
        "err"
      );
      return false;
    }
    return true;
  }
}
